// extracted by mini-css-extract-plugin
export default {"root":"SimpleCard_root__0P4Ne"};